import EfImg from '@elem/ui/ef-img';
import EcoVideo from 'eco-design/base/eco-video';
import styles from './index.module.scss';

interface SectionCardProps {
    title: string;
    desc?: string;
    desc1?: string;
    isVideo?: boolean;
    pc: string;
    h5: string;
}

export default function SectionCard({ title, desc, desc1, pc, h5, isVideo }: SectionCardProps) {
    return (
        <div className={styles.SectionCard}>
            <div className="sectioncard-container">
                <div className="left">
                    {isVideo ? (
                        <EcoVideo
                            pc={pc}
                            h5={h5}
                            // poster="https://websiteoss.ecoflow.com/upload/image/1744639487982/c.jpg"
                            autoPlay={true}
                            loop={true}
                        />
                    ) : (
                        <EfImg className="item-img" pc={pc} h5={h5} />
                    )}
                </div>
                <div className="right">
                    <div className="sectioncard-title">{title}</div>
                    {desc && <div className="sectioncard-desc">{desc}</div>}
                    {desc1 && <div className="sectioncard-desc1">{desc1}</div>}
                </div>
            </div>
        </div>
    );
}
